import initialState from "./InitialStates";
import {message} from "antd";
import Action from "../actions/Actions";
import update from "immutability-helper";


const UserManagementReducer = (state = initialState.userManagement, action) => {
    switch (action.type) {
    case Action.USER_MGT_REQUEST:
        return update(state, {
            isLoading: {$set: true},
            userId: {$set: ""},
            status: {$set: ""},
            userAttributes: {$set: {}},
            userCreateDate: {$set: ""},
            userLastModifiedDate: {$set: ""},
            enabled: {$set: ""},
            isEditing: {$set: false},
            isUserExist: {$set: false}
        });

    case Action.USER_MGT_SUCCESS:
        return update(state, {
            isLoading: {$set: false},
            userId: {$set: action.payload.userid},
            status: {$set: action.payload.userStatus},
            userAttributes: {$set: action.payload.userAttributes},
            userCreateDate: {$set: action.payload.userCreateDate},
            userLastModifiedDate: {$set: action.payload.userLastModifiedDate},
            enabled: {$set: action.payload.enabled},
            isUserExist: {$set: true},
            groups: {$set: action.groups}
        });

    case Action.USER_MGT_FAIL:
        return update(state, {
            isLoading: {$set: false},
            isUserExist: {$set: false}
        });

    case Action.USER_STATE_CHG_REQUEST:
        return update(state, {
            isEditing: {$set: true}
        });

    case Action.USER_STATE_CHG_SUCCESS:
        message.success(action.message);
        return update(state, {
            isEditing: {$set: false}
        });

    case Action.USER_STATE_CHG_FAIL:
        message.error(action.message, 5);
        return update(state, {
            isEditing: {$set: false}
        });

    case Action.USER_ATTR_CHG_REQUEST:
        return update(state, {
            isEditing: {$set: true}
        });

    case Action.USER_ATTR_CHG_SUCCESS:
        message.success(action.message);
        return update(state, {
            isEditing: {$set: false}
        });

    case Action.USER_ATTR_CHG_FAIL:
        message.error(action.message, 5);
        return update(state, {
            isEditing: {$set: false}
        });

    default:
        return state;
    }
};

export default UserManagementReducer;